exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".deal-card {\n    padding: 10px;\n    border: 1px solid #ddd;\n}", ""]);

// exports
